import React from 'react';
import { images } from '../shared/assets';
import { ContentfulImage } from '../Contentful';
import './MainLodgeSection.css';

interface MainLodgeSectionProps {
  property?: string;
}

const MainLodgeSection: React.FC<MainLodgeSectionProps> = ({ property = "patagonia" }) => {
  // Get property-specific content
  const getContentForProperty = () => {
    switch (property.toLowerCase()) {
      case 'iguazu':
        return {
          title: "Nestled in the jungle",
          description: "Stepping away from the layout of a classic hotel, we have created Villas nestled in the jungle. These offer the ideal balance between seclusion and connection, with the option to socialise at the bar and our Relais & Châteaux restaurant in the main lodge.",
          additionalInfo: "Built on stilts for minimal environmental impact, the 14 Villas are spread throughout the jungle, each positioned for utmost privacy but within easy distance of the main lodge. There are 13 standard Villas, and 1 Master Villa. Awasi Iguazú is the perfect place to enjoy the very best of the Misiones Province, Argentina."
        };
      case 'mendoza':
        return {
          title: "Nestled in a 55 acre vineyard",
          description: "Awasi Mendoza is a 17 room property strategically located between the best known wineries and the magnificent Andes Mountain range. Only a half hour drive south of Mendoza city.",
          additionalInfo: "Immerse yourself in the heart of wine country with our collection of self-standing accommodations, each offering breathtaking views of the Andes Mountains. Ranging from intimate vineyard hideaways to expansive villas, every room is designed for privacy, space, and serenity."
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          title: "Main Lodge",
          description: "A tapestry of unique elements: mountains and beaches, Azorean traditions and European influences and fishing villages. Santa Catarina invites discovery, and our lodge is strategically positioned for those who want to dive into this universe.",
          additionalInfo: "A natural preservation area, highlighted by the exuberance of the Atlantic Forest and small coves, creates the ideal setting for days of disconnecting from the outside world, focusing on well-being and contemplating nature. Experience tranquility and comfort in one of our 25 Villas."
        };
      case 'patagonia':
      default:
        return {
          title: "A place to create memories",
          description: "Awasi Patagonia's strategic location allows you to experience Torres del Paine National Park from the intimacy of a private reserve, away from the crowds and traffic found in high season. Inspired by traditional Patagonian shelters and estate 'outposts', we have built just 14 Villas on the Awasi private reserve, including one master Villa with two suites.",
          additionalInfo: "Step back from the rush of the 21st century into a place practically untouched by time, where nature rules and you feel the power of the elements. Ice and wind have shaped the landscape around you: stark peaks are circumnavigated by condors, and on the wide open plains pumas prowl and guanacos call out. After days exploring the steppe, mountains and glaciers, return to Awasi Patagonia for a drink by the fire and long evening meals at our Relais & Châteaux restaurant. The perfect spot to enjoy Torres del Paine National Park at your own pace with the comfort of a private reserve and your own Villa."
        };
    }
  };
  
  const content = getContentForProperty();
  
  return (
    <div className="villa-section-wide">
      <ContentfulImage imageKey="villa-interior-1" fallbackSrc={images.villaInterior} alt="Villa Interior" className="villa-main-img" />
      <div className="villa-content">
        <div className="villa-text">
          <h2>{content.title}</h2>
          <p>{content.description}</p>
          {content.additionalInfo && <p>{content.additionalInfo}</p>}
          <ContentfulImage imageKey="villa-interior-1" fallbackSrc={images.villaDetail} alt="Villa Detail" className="lodge-detail-img" />
        </div>
      </div>
      <img src={images.lodgeExterior} alt="Lodge Exterior" className="lodge-exterior-img" />
    </div>
  );
};

export default MainLodgeSection; 